import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { BrokerService } from '@c4/core';

import { Device } from '../../../common/interfaces/item.interface';
import { Command } from '../../../common/params/interfaces/command.interface';
import { Parameter } from '../../../common/params/interfaces/parameter.interface';
import { C4ValueType } from '../../../common/params/param-input.component';
import { ProgrammingUtilsService as Util } from '../../../common/services/utils.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';
import { SharedProgrammingService, CommonProgrammingContext, CommandData } from '../../../common/services/shared-programming.service';

import { ThermostatProgrammingContext } from '../quickstart-thermostats.service';

@Component({
  templateUrl: './select-params.component.html',
  styleUrls: ['./select-params.component.less']
})
export class QSThermostatSelectParamsComponent extends BaseRoutingComponent {

  private _thermostat: Observable<Device>;
  private _command: Command;
  private _parameters: Parameter[];

  constructor(
    public router: Router,
    private _route: ActivatedRoute,
    protected store: Store<{
      thermostatProgramming: ThermostatProgrammingContext,
      sharedProgramming: CommonProgrammingContext
    }>,
    private _broker: BrokerService,
    private _shared: SharedProgrammingService
  ) {
    super();

    this._route.params
      .flatMap((params: { id: string, command: string }) => this._broker.call({
        path: `/api/v1/items/commands`,
        queryString: {
          query: {
            command: params.command,
            deviceId: parseInt(params.id)
          }
        }
      }))
      .map((commands: Command[]) => commands[0])
      .subscribe(command => {
        this._command = command;
        this._parameters = command.params;
      });

  }

  private _configured = (): boolean => {
    return (this._parameters || []).every(param => {
      return param.value != undefined || param._value != undefined;
    });
  }

  private saveCommand = () => {

    if (!this._configured()) {
      return;
    }

    let params = this._parameters
      .filter(p => !!p)
      .map(p => {
        p._value = p._value || p.value
        return p;
      });

    let data: CommandData = {
      codeitemId: 0,
      deviceId: this._command.deviceId,
      command: this._command.command,
      beforeCodeItemId: 0,
      parentCodeItemId: 0,
      creator: '',
      type: 1,
      params: this._parameters.map(p => {
        return {
          name: p.name,
          value: p._value
        }
      })
    };

    this._shared.saveAction(data);
  }

  private update = (param: Parameter, value: C4ValueType) => {
    let ix = this._parameters.findIndex(p => param.name == p.name && param.type == p.type);
    this._parameters[ix] = Object.assign({}, this._parameters[ix], {
      _display: value.display,
      _value: value.value
    });

    this._parameters = [...this._parameters];
  }

  private identify = (param: Parameter) => param.name + param.type;
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-thermostats/select-params/select-params.component.ts